"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var HIDDEN = 'is-hidden';
var TOTAL_STEPS = 4;
var ANCHOR_ID = 'enepi-alliance-anchor';
var DISMISSED_KEY = 'enepiFloatingCtaDismissed';
var BODY_FLOATING_SHOWN = 'is-enepiFloatingCtaShown';
var BODY_POPUP_OPEN = 'is-enepiPopupOpen';
var ENERGY_LABEL = { gas: 'ガス（プロパンガス）', electricity: '電気' };
var HOUSE_LABEL = {
    detached: '戸建て',
    apartment: 'マンション・アパート',
    store_ex: '店舗・事務所',
};
var OWNERSHIP_LABEL = { owner: '物件オーナー', borrower: '賃貸・分譲入居者' };
var ESTIMATE_LABEL = { change_contract: '現在の住まい', new_contract: '引っ越し先' };
var ENERGY_KIND_LABEL = {
    electricity_citygas: '電気と都市ガス',
    electricity_lpgas: '電気とプロパンガス',
    electricity: 'オール電化',
};
var HOUSE_CHOICES = [
    { label: '戸建て', sub: '一戸建て・二世帯住宅など', value: 'detached' },
    { label: 'マンション・アパート', sub: '集合住宅', value: 'apartment' },
    { label: '店舗・事務所', sub: 'お店・オフィス・工場など', value: 'store_ex' },
];
var joinCrumb = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    return parts.filter(Boolean).join(' ／ ');
};
// GTM で扱いやすいよう、id はケバブケースにそろえる（houseKind → house-kind, store_ex → store-ex）
var toKebab = function (value) { return value.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/_/g, '-').toLowerCase(); };
var STEPS = {
    energy: {
        crumb: function () { return ''; },
        question: '比べたいのは、どちらですか？',
        note: '都市ガスのみをご利用の方は「電気」をお選びください。エネピのご利用は任意です。',
        layout: 'pair',
        progress: 1,
        choices: [
            { label: 'ガス', sub: 'プロパンガスが対象', value: 'gas' },
            { label: '電気', sub: 'お住まい・店舗の電気', value: 'electricity' },
        ],
    },
    houseKind: {
        crumb: function (a) { return ENERGY_LABEL[a.energy || '']; },
        question: '物件種別をお選びください',
        layout: 'list',
        progress: 2,
        choices: HOUSE_CHOICES,
    },
    ownership: {
        crumb: function (a) { return joinCrumb(ENERGY_LABEL[a.energy || ''], 'マンション・アパート'); },
        question: '所有種別をお選びください',
        layout: 'list',
        progress: 2,
        choices: [
            { label: '物件オーナー', sub: '建物を所有している方', value: 'owner' },
            { label: '賃貸・分譲入居者', sub: 'お部屋にお住まいの方', value: 'borrower' },
        ],
    },
    estimateKind: {
        crumb: function (a) { return joinCrumb(ENERGY_LABEL[a.energy || ''], HOUSE_LABEL[a.houseKind || '']); },
        question: '利用先をお選びください',
        layout: 'pair',
        progress: 3,
        choices: [
            { label: '現在の住まい', sub: 'いま使っている料金を切り替える', value: 'change_contract' },
            { label: '引っ越し先', sub: 'これから住む場所で新しく契約する', value: 'new_contract' },
        ],
    },
    energyKind: {
        crumb: function (a) { return joinCrumb('電気', HOUSE_LABEL[a.houseKind || ''], ESTIMATE_LABEL[a.estimateKind || '']); },
        question: '現在ご利用のエネルギーをお選びください。',
        layout: 'list',
        progress: 4,
        choices: [
            { label: '電気と都市ガス', sub: '都市ガスの配管がある', value: 'electricity_citygas' },
            { label: '電気とプロパンガス', sub: 'ボンベ・貯槽がある', value: 'electricity_lpgas' },
            { label: 'オール電化', sub: '給湯・調理なども電気', value: 'electricity' },
        ],
    },
    done: {
        crumb: function (a) { return joinCrumb(ENERGY_LABEL[a.energy || ''], '回答完了'); },
        question: 'エネピの見積もりフォームへ進みます',
        layout: 'list',
        progress: TOTAL_STEPS,
        choices: [],
    },
};
var STEP_KEY = {
    energy: 'energy',
    houseKind: 'houseKind',
    ownership: 'ownership',
    estimateKind: 'estimateKind',
    energyKind: 'energyKind',
};
// sessionStorage はプライベートブラウズ等で例外を投げることがあるため、失敗しても動作を止めない
var readDismissed = function () {
    try {
        return window.sessionStorage.getItem(DISMISSED_KEY) === '1';
    }
    catch (e) {
        return false;
    }
};
var writeDismissed = function () {
    try {
        window.sessionStorage.setItem(DISMISSED_KEY, '1');
    }
    catch (e) {
        // 保存できなくても、このページ表示中は閉じたままになる
    }
};
var EnepiAllianceController = /** @class */ (function (_super) {
    __extends(EnepiAllianceController, _super);
    function EnepiAllianceController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.answers = {};
        _this.history = [];
        _this.current = 'energy';
        _this.selected = null;
        _this.dismissed = false;
        _this.lastFocused = null;
        _this.anchorObserver = null;
        _this.onKeydown = function (event) {
            if (_this.popupTarget.classList.contains(HIDDEN)) {
                return;
            }
            if (event.key === 'Escape') {
                _this.close();
            }
            else if (event.key === 'Tab') {
                _this.trapFocus(event);
            }
        };
        return _this;
    }
    EnepiAllianceController.prototype.connect = function () {
        // 祖先の transform / overflow / z-index の影響を受けないよう body 直下へ移す。
        // 移動すると stimulus が disconnect → connect し直すので、初期化は移動後に行う。
        if (this.element.parentElement !== document.body) {
            document.body.appendChild(this.element);
            return;
        }
        this.dismissed = readDismissed();
        document.addEventListener('keydown', this.onKeydown);
        this.observeAnchor();
    };
    EnepiAllianceController.prototype.disconnect = function () {
        document.removeEventListener('keydown', this.onKeydown);
        if (this.anchorObserver) {
            this.anchorObserver.disconnect();
            this.anchorObserver = null;
        }
        document.body.classList.remove(BODY_FLOATING_SHOWN, BODY_POPUP_OPEN);
    };
    // フローティングCTA → 訴求ポップアップ
    EnepiAllianceController.prototype.open = function (e) {
        if (e) {
            e.preventDefault();
        }
        this.lastFocused = document.activeElement;
        this.showIntro();
        this.popupTarget.classList.remove(HIDDEN);
        this.popupTarget.setAttribute('aria-hidden', 'false');
        document.body.classList.add(BODY_POPUP_OPEN);
        // フォーカスがポップアップの外（フローティングCTA）に残らないよう、ダイアログ内へ移す
        this.focusFirst();
    };
    // 訴求の「ガス・電気の料金を比較」→ 同じサイズのまま設問へ
    EnepiAllianceController.prototype.start = function () {
        this.panelTarget.style.height = "".concat(this.panelTarget.getBoundingClientRect().height, "px");
        this.introTarget.classList.add(HIDDEN);
        this.stepsTarget.classList.remove(HIDDEN);
        this.answers = {};
        this.history = [];
        this.current = 'energy';
        this.selected = null;
        this.render();
    };
    EnepiAllianceController.prototype.close = function () {
        this.popupTarget.classList.add(HIDDEN);
        this.popupTarget.setAttribute('aria-hidden', 'true');
        document.body.classList.remove(BODY_POPUP_OPEN);
        if (this.lastFocused) {
            this.lastFocused.focus();
        }
    };
    // フローティングCTAの ✕。同じセッション中は再表示しない
    EnepiAllianceController.prototype.dismiss = function () {
        this.dismissed = true;
        writeDismissed();
        this.toggleFloating(false);
    };
    // 選んだ回答を確定して次の設問へ
    EnepiAllianceController.prototype.next = function () {
        if (!this.selected) {
            return;
        }
        this.popupTarget.setAttribute('data-enepi-last-answer', "".concat(toKebab(this.current), "-").concat(toKebab(this.selected)));
        this.answers[STEP_KEY[this.current]] = this.selected;
        this.history.push(this.current);
        this.current = this.nextStep();
        this.selected = null;
        this.render();
    };
    // 1問戻る。戻った設問は前回の回答を選んだ状態で表示する
    EnepiAllianceController.prototype.back = function () {
        var previous = this.history.pop();
        if (!previous) {
            return;
        }
        this.selected = this.answers[STEP_KEY[previous]] || null;
        delete this.answers[STEP_KEY[this.current]];
        delete this.answers[STEP_KEY[previous]];
        this.current = previous;
        this.render();
    };
    // AI査定LPのチャット内では完了ビューが表示されるまで目印が display: none の祖先の中にある。
    // 目印の大きさが 0 → 1px に変わったら表示されたとみなしてフローティングCTAを出す。
    EnepiAllianceController.prototype.observeAnchor = function () {
        var _this = this;
        var anchor = document.getElementById(ANCHOR_ID);
        var update = function () { return _this.toggleFloating(!anchor || anchor.getClientRects().length > 0); };
        if (anchor && 'ResizeObserver' in window) {
            this.anchorObserver = new ResizeObserver(update);
            this.anchorObserver.observe(anchor);
        }
        update();
    };
    EnepiAllianceController.prototype.toggleFloating = function (visible) {
        var shown = visible && !this.dismissed;
        this.floatingTarget.classList.toggle(HIDDEN, !shown);
        document.body.classList.toggle(BODY_FLOATING_SHOWN, shown);
    };
    EnepiAllianceController.prototype.showIntro = function () {
        this.panelTarget.style.height = '';
        this.introTarget.classList.remove(HIDDEN);
        this.introTarget.scrollTop = 0;
        this.stepsTarget.classList.add(HIDDEN);
        this.popupTarget.setAttribute('data-enepi-step', 'intro');
    };
    EnepiAllianceController.prototype.nextStep = function () {
        var _a = this.answers, energy = _a.energy, houseKind = _a.houseKind, ownership = _a.ownership, estimateKind = _a.estimateKind, energyKind = _a.energyKind;
        if (!energy)
            return 'energy';
        if (!houseKind)
            return 'houseKind';
        // 所有種別はガス×マンション・アパートのときだけ必要
        if (energy === 'gas' && houseKind === 'apartment' && !ownership)
            return 'ownership';
        if (!estimateKind)
            return 'estimateKind';
        // 電気は energy_kind が無いと先方のステップをスキップできない
        if (energy === 'electricity' && !energyKind)
            return 'energyKind';
        return 'done';
    };
    // 選択肢のタップでは進まず、選択状態だけ切り替える
    EnepiAllianceController.prototype.select = function (value) {
        this.selected = value;
        Array.prototype.forEach.call(this.choicesTarget.children, function (button) {
            var isSelected = button.getAttribute('data-value') === value;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', String(isSelected));
        });
        this.nextTarget.disabled = false;
    };
    EnepiAllianceController.prototype.render = function () {
        var step = STEPS[this.current];
        var isDone = this.current === 'done';
        var crumb = step.crumb(this.answers);
        this.popupTarget.setAttribute('data-enepi-step', toKebab(this.current));
        this.crumbTarget.textContent = crumb;
        this.crumbTarget.classList.toggle(HIDDEN, !crumb);
        this.questionTarget.textContent = step.question;
        this.noteTarget.textContent = step.note || '';
        this.noteTarget.classList.toggle(HIDDEN, !step.note);
        this.renderProgress(step.progress, isDone);
        this.renderChoices(step);
        this.renderDone(isDone);
        // 最初の設問では「前の質問へ」を出さず、「次へ」を横幅いっぱいにする
        this.backTarget.classList.toggle(HIDDEN, this.history.length === 0);
        this.nextTarget.classList.toggle(HIDDEN, isDone);
        this.nextTarget.disabled = !this.selected;
        // 押したボタン（開始・次へ）が隠れたり押せなくなったりするため、新しい設問へフォーカスを移す
        this.questionTarget.focus();
    };
    // ポップアップ内で操作できる要素。非表示（祖先が display: none）のものは除く
    EnepiAllianceController.prototype.focusableElements = function () {
        var selector = 'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
        var elements = Array.prototype.slice.call(this.popupTarget.querySelectorAll(selector));
        return elements.filter(function (element) { return element.getClientRects().length > 0; });
    };
    EnepiAllianceController.prototype.focusFirst = function () {
        var first = this.focusableElements()[0];
        if (first) {
            first.focus();
        }
    };
    // Tab / Shift+Tab でフォーカスがダイアログの外（背後のページ）へ出ないよう、端で反対側へ回す
    EnepiAllianceController.prototype.trapFocus = function (event) {
        var elements = this.focusableElements();
        if (elements.length === 0) {
            event.preventDefault();
            return;
        }
        var first = elements[0];
        var last = elements[elements.length - 1];
        var active = document.activeElement;
        var inside = !!active && this.popupTarget.contains(active);
        if (event.shiftKey && (active === first || !inside)) {
            event.preventDefault();
            last.focus();
        }
        else if (!event.shiftKey && (active === last || !inside)) {
            event.preventDefault();
            first.focus();
        }
    };
    EnepiAllianceController.prototype.renderProgress = function (progress, isDone) {
        this.progressLabelTarget.textContent = isDone
            ? "\u56DE\u7B54\u305A\u307F ".concat(TOTAL_STEPS, "/").concat(TOTAL_STEPS)
            : "STEP ".concat(progress, " / ").concat(TOTAL_STEPS);
        this.progressLabelTarget.classList.toggle('is-done', isDone);
        this.segmentTargets.forEach(function (segment, index) {
            // 完了時は全段を完了色にする
            segment.classList.toggle('is-filled', index + 1 <= progress);
            segment.classList.toggle('is-done', isDone);
        });
    };
    EnepiAllianceController.prototype.renderChoices = function (step) {
        var _this = this;
        this.choicesTarget.innerHTML = '';
        this.choicesTarget.classList.toggle('enepiPopup_Choices-pair', step.layout === 'pair');
        this.choicesTarget.classList.toggle(HIDDEN, step.choices.length === 0);
        step.choices.forEach(function (choice) {
            _this.choicesTarget.appendChild(_this.buildChoice(choice));
        });
    };
    EnepiAllianceController.prototype.buildChoice = function (choice) {
        var _this = this;
        var button = document.createElement('button');
        var isSelected = choice.value === this.selected;
        button.type = 'button';
        button.id = "enepi-popup-choice-".concat(toKebab(this.current), "-").concat(toKebab(choice.value));
        button.className = isSelected ? 'enepiPopup_Choice is-selected' : 'enepiPopup_Choice';
        button.setAttribute('data-value', choice.value);
        button.setAttribute('aria-pressed', String(isSelected));
        button.addEventListener('click', function () { return _this.select(choice.value); });
        var label = document.createElement('span');
        label.className = 'enepiPopup_ChoiceLabel';
        label.textContent = choice.label;
        button.appendChild(label);
        if (choice.sub) {
            var sub = document.createElement('span');
            sub.className = 'enepiPopup_ChoiceSub';
            sub.textContent = choice.sub;
            button.appendChild(sub);
        }
        return button;
    };
    EnepiAllianceController.prototype.renderDone = function (isDone) {
        var _this = this;
        this.doneTarget.classList.toggle(HIDDEN, !isDone);
        if (!isDone) {
            return;
        }
        this.summaryTarget.innerHTML = '';
        this.summaryRows().forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var row = document.createElement('div');
            row.className = 'enepiPopup_SummaryRow';
            var term = document.createElement('dt');
            term.className = 'enepiPopup_SummaryKey';
            term.textContent = key;
            var desc = document.createElement('dd');
            desc.className = 'enepiPopup_SummaryValue';
            desc.textContent = value;
            row.appendChild(term);
            row.appendChild(desc);
            _this.summaryTarget.appendChild(row);
        });
        this.transferTarget.href = this.buildUrl();
    };
    EnepiAllianceController.prototype.summaryRows = function () {
        var _a = this.answers, energy = _a.energy, houseKind = _a.houseKind, ownership = _a.ownership, estimateKind = _a.estimateKind, energyKind = _a.energyKind;
        var rows = [['比べる料金', energy === 'gas' ? 'プロパンガス' : '電気']];
        if (energyKind)
            rows.push(['エネルギー', ENERGY_KIND_LABEL[energyKind]]);
        if (houseKind)
            rows.push(['建物', HOUSE_LABEL[houseKind]]);
        if (ownership)
            rows.push(['お立場', OWNERSHIP_LABEL[ownership]]);
        if (estimateKind)
            rows.push(['ご利用先', ESTIMATE_LABEL[estimateKind]]);
        return rows;
    };
    EnepiAllianceController.prototype.buildUrl = function () {
        var _a = this.answers, energy = _a.energy, houseKind = _a.houseKind, ownership = _a.ownership, estimateKind = _a.estimateKind, energyKind = _a.energyKind;
        var isGas = energy === 'gas';
        var base = (isGas ? this.data.get('gasUrl') : this.data.get('electricityUrl')) || '';
        var params = [];
        var add = function (key, value) {
            params.push("".concat(key, "=").concat(encodeURIComponent(value)));
        };
        // ガスフォームに energy_kind を付けると、プロパンの申込が電気として登録される
        if (!isGas && energyKind)
            add('energy_kind', energyKind);
        if (houseKind)
            add('house_kind', houseKind);
        // 送信直前に既定値が補完されるため、推測できる場合でも必ず明示する
        add('ownership_kind', ownership || this.defaultOwnership());
        if (estimateKind)
            add('estimate_kind', estimateKind);
        var pr = this.data.get('pr');
        if (pr)
            add('pr', pr);
        return "".concat(base, "?").concat(params.join('&'));
    };
    // 所有種別を聞かなかったときに渡す値。先方の電気フォームに合わせ、電気×マンション・アパートだけ borrower にする
    EnepiAllianceController.prototype.defaultOwnership = function () {
        var _a = this.answers, energy = _a.energy, houseKind = _a.houseKind;
        return energy === 'electricity' && houseKind === 'apartment' ? 'borrower' : 'owner';
    };
    EnepiAllianceController.targets = [
        'floating',
        'popup',
        'panel',
        'intro',
        'steps',
        'crumb',
        'question',
        'note',
        'choices',
        'progressLabel',
        'segment',
        'done',
        'summary',
        'transfer',
        'back',
        'next',
    ];
    return EnepiAllianceController;
}(stimulus_1.Controller));
exports.default = EnepiAllianceController;
